import { useSearchEngineStore } from '../../../stores/searchStore'

export const ShareCommission = () => {
  const { sharesCommission, setSharesCommission } = useSearchEngineStore((state) => state)

  const handleOnClick = () => {
    setSharesCommission(!sharesCommission)
  }
  return(
    <div className="flex items-center gap-x-2.5 md:my-0 my-4">
      <span className="text-normal font-semibold text-[#222]">
        Propiedades con comisión compartida
      </span>
      <button onClick={handleOnClick} className={`p-1 rounded-3xl flex transition-all duration-300  cursor-pointer h-6 w-10 ${sharesCommission ? 'bg-[#222]' : 'bg-[#D5D8DE]'}`}>
        <div className={`rounded-full transition-all duration-150 w-4 h-4 !bg-white ${sharesCommission ? 'translate-x-4' : 'translate-x-0'}`}></div>
      </button>
    </div>
  )
}


